export default {
  daysToDate: 0,
  displayYear: '',
  midDrainageModalFlag: false,
  dviGraphModalFlag: false,
  stageListModalFlag: false,
  imgDate: 0,
  imgId: 0,
  maxDate: '',
  stageData: [],
  graphRange: []
}
